import { createPayment } from './reducers';
export default createPayment;
